// extracted by mini-css-extract-plugin
export default {"userManagementContainer":"_user-management_userManagementContainer__VvaT5"};